import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './components/App/App.jsx'
import store from './store'
import theme from './themes/main'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { StripeProvider } from 'react-stripe-elements'
import './index.css'
import * as serviceWorker from './serviceWorker'
let stripeKey

if (process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_ENV === 'stage') {
  stripeKey = process.env.REACT_APP_LIVE_STRIPE_KEY
  //stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY
} else {
  stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY
}

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <StripeProvider apiKey={stripeKey}>
        <App dispatch={store.dispatch} />
      </StripeProvider>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('⚛️')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
